module.exports = __webpack_public_path__ + "img/bk_14.90e6ec67.png";